// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JyF5QpYSWlrE7zvPGshg {
  width: 100%;
  padding: 1rem;
  font-family: Noto Sans
}

.ifztpFHjVSf_huj26bSw {
  margin-bottom: 14px
}

.baqwgytKnaz7wjAxjTkQ {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.25rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-top: 6rem;
  padding-bottom: 6rem;
  padding-left: 8rem;
  padding-right: 8rem
}

.ghgEYGnEjL0H_5Jerm4H {
  height: 56vh;
  list-style-position: inside;
  list-style-type: decimal
}

.ghgEYGnEjL0H_5Jerm4H > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse))
}

.ghgEYGnEjL0H_5Jerm4H {
  overflow-y: scroll;
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
  padding-left: 1.75rem
}

.ghgEYGnEjL0H_5Jerm4H li {
  padding-left: 1.25rem;
  text-indent: -1.25rem
}

.t6XySnorKFiDockOul6F {
}

.Av6531V1F4nKm2mmD20g {
}

.LPB9__dxBE8FcWVBFpmA {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 0.5rem
}

.Bwv8BBTomuaLizDzIBN8 {
  height: 38px;
  width: 237px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.Bwv8BBTomuaLizDzIBN8:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.Bwv8BBTomuaLizDzIBN8:disabled,
.Bwv8BBTomuaLizDzIBN8[disabled] {
  cursor: not-allowed;
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.Bwv8BBTomuaLizDzIBN8:disabled:hover,
.Bwv8BBTomuaLizDzIBN8[disabled]:hover {
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.EhpY1zrA50lvZ7_j93XY {
  display: flex;
  height: 13rem;
  width: 100%;
  align-items: center;
  justify-content: center
}

.jNZrn3xI4WYH9Oa7OMJ6 {
  max-height: 500px;
  max-width: none;
  overflow-y: auto
}

.NvzXvHM7cKEiwn04J83B {
  margin-top: 0.25rem;
  height: 0.875rem;
  width: auto
}

.cGn9n04HD8WFeKhAveb2 {
  height: 38px;
  width: 237px;
  border-radius: 5px;
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 49 49 / var(--tw-bg-opacity, 1)) !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.cGn9n04HD8WFeKhAveb2:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.cGn9n04HD8WFeKhAveb2:disabled,
.cGn9n04HD8WFeKhAveb2[disabled] {
  cursor: not-allowed;
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.cGn9n04HD8WFeKhAveb2:disabled:hover,
.cGn9n04HD8WFeKhAveb2[disabled]:hover {
  border-style: none;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.FfWTqq0cv04zTci3wd5y {
  display: flex;
  align-items: center;
  gap: 0.5rem
}
`, "",{"version":3,"sources":["webpack://./src/pages/CustomerConsent/CustomerConsent.module.css"],"names":[],"mappings":"AACE;EAAA,WAA4B;EAA5B,aAA4B;EAA5B;AAA4B;;AAI5B;EAAA;AAAgB;;AAIhB;EAAA,aAAiE;EAAjE,WAAiE;EAAjE,sBAAiE;EAAjE,YAAiE;EAAjE,qBAAiE;EAAjE,kBAAiE;EAAjE,4DAAiE;EAAjE,iBAAiE;EAAjE,oBAAiE;EAAjE,kBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,YAAiI;EAAjI,2BAAiI;EAAjI;AAAiI;;AAAjI;EAAA,uBAAiI;EAAjI,4DAAiI;EAAjI;AAAiI;;AAAjI;EAAA,kBAAiI;EAAjI,sBAAiI;EAAjI,mBAAiI;EAAjI,oBAAiI;EAAjI,gBAAiI;EAAjI,kBAAiI;EAAjI,oBAAiI;EAAjI,gDAAiI;EACjI;AADiI;;AAKjI;EACA,qBAAqB;EACrB;AAFW;;AAKb;AACA;;AAEA;AACA;;AAGE;EAAA,aAAoC;EAApC,WAAoC;EAApC,yBAAoC;EAApC;AAAoC;;AAIpC;EAAA,YAAkG;EAAlG,YAAkG;EAAlG,kBAAkG;EAAlG,0DAAkG;EAAlG,sBAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;;AAKhC;;EAAA,mBAAiE;EAAjE,kBAAiE;EAAjE,6BAAiE;EAAjE,uEAAiE;EAAjE,+BAAiE;EAAjE;AAAiE;;AAKjE;;EAAA,kBAA8C;EAA9C,6BAA8C;EAA9C,uEAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,aAAmD;EAAnD,aAAmD;EAAnD,WAAmD;EAAnD,mBAAmD;EAAnD;AAAmD;;AAInD;EAAA,iBAA+C;EAA/C,eAA+C;EAA/C;AAA+C;;AAI/C;EAAA,mBAAwB;EAAxB,gBAAwB;EAAxB;AAAwB;;AAIxB;EAAA,YAA2H;EAA3H,YAA2H;EAA3H,kBAA2H;EAA3H,kBAA2H;EAA3H,6BAA2H;EAA3H,qEAA2H;EAA3H,mBAA2H;EAA3H,oBAA2H;EAA3H,gBAA2H;EAA3H,+BAA2H;EAA3H;AAA2H;;AAA3H;EAAA,+BAA2H;EAA3H;AAA2H;;AAK3H;;EAAA,mBAAiE;EAAjE,kBAAiE;EAAjE,6BAAiE;EAAjE,uEAAiE;EAAjE,+BAAiE;EAAjE;AAAiE;;AAKjE;;EAAA,kBAA8C;EAA9C,6BAA8C;EAA9C,uEAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B","sourcesContent":[".container {\n  @apply w-full p-4 font-inter;\n}\n\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n\n.pageBody {\n  @apply w-full flex flex-col gap-5 bg-white rounded-lg py-24 px-32;\n}\n\n.list {\n  @apply list-decimal list-inside space-y-4 text-gray-700 leading-relaxed text-sm font-normal overflow-y-scroll h-[56vh] font-inter;\n  padding-left: 1.75rem;\n}\n\n.list li {\n  @apply pl-1;\n  padding-left: 1.25rem;\n  text-indent: -1.25rem;\n}\n\n.previewPledgeWrapper {\n}\n\n.termsAndConditionWrapper {\n}\n\n.buttonWrapper {\n  @apply w-full flex justify-end gap-2;\n}\n\n.applyButton {\n  @apply bg-secondary text-white w-[237px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.applyButton:disabled,\n.applyButton[disabled] {\n  @apply !bg-gray-100 !text-gray-300 border-none cursor-not-allowed;\n}\n\n.applyButton:disabled:hover,\n.applyButton[disabled]:hover {\n  @apply !bg-gray-100 !text-gray-300 border-none;\n}\n\n.loaderWrapper {\n  @apply w-full h-52 flex items-center justify-center;\n}\n\n.termsContent {\n  @apply max-w-none max-h-[500px] overflow-y-auto;\n}\n\n.singpassLogo {\n  @apply h-3.5 w-auto mt-1;\n}\n\n.dangerButton {\n  @apply !bg-danger-100 w-[237px] h-[38px] text-sm font-dashboardMain !text-white rounded-[5px] hover:!text-white border-none;\n}\n\n.dangerButton:disabled,\n.dangerButton[disabled] {\n  @apply !bg-gray-100 !text-gray-300 border-none cursor-not-allowed;\n}\n\n.dangerButton:disabled:hover,\n.dangerButton[disabled]:hover {\n  @apply !bg-gray-100 !text-gray-300 border-none;\n}\n\n.singpassContent {\n  @apply flex items-center gap-2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JyF5QpYSWlrE7zvPGshg`,
	"customBreadCrumbs": `ifztpFHjVSf_huj26bSw`,
	"pageBody": `baqwgytKnaz7wjAxjTkQ`,
	"list": `ghgEYGnEjL0H_5Jerm4H`,
	"previewPledgeWrapper": `t6XySnorKFiDockOul6F`,
	"termsAndConditionWrapper": `Av6531V1F4nKm2mmD20g`,
	"buttonWrapper": `LPB9__dxBE8FcWVBFpmA`,
	"applyButton": `Bwv8BBTomuaLizDzIBN8`,
	"loaderWrapper": `EhpY1zrA50lvZ7_j93XY`,
	"termsContent": `jNZrn3xI4WYH9Oa7OMJ6`,
	"singpassLogo": `NvzXvHM7cKEiwn04J83B`,
	"dangerButton": `cGn9n04HD8WFeKhAveb2`,
	"singpassContent": `FfWTqq0cv04zTci3wd5y`
};
export default ___CSS_LOADER_EXPORT___;
